import React, { useEffect, useState } from 'react';
import { 
  Box, 
  Typography, 
  Paper, 
  Button, 
  CircularProgress, 
  Card,
  CardContent,
  CardActions,
  Chip,
  Divider,
  InputBase,
  IconButton,
  Tab,
  Tabs,
  Menu,
  MenuItem,
  Stack,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  // FormControl,
  // Select,
  // InputLabel,
  // useMediaQuery, // Hapus import yang tidak digunakan
  // useTheme, // Hapus import yang tidak digunakan
  Container
} from '@mui/material';
import { useSnackbar } from 'notistack';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../services/api';
import MainLayout from '../components/layout/MainLayout';
import { t } from '../utils/textUtils';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import FilterListIcon from '@mui/icons-material/FilterList';
import SortIcon from '@mui/icons-material/Sort';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PersonIcon from '@mui/icons-material/Person';

const Projects = () => {
  const { user } = useAuth();
  const navigate = useNavigate();
  const { enqueueSnackbar } = useSnackbar();
  // Hapus variabel yang tidak digunakan
  // const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  // Definisikan semua state di awal komponen
  const [loading, setLoading] = useState(true);
  const [projects, setProjects] = useState([]);
  const [error, setError] = useState(null);
  const [searchQuery, setSearchQuery] = useState('');
  const [tabValue, setTabValue] = useState(0);
  const [filterAnchorEl, setFilterAnchorEl] = useState(null);
  const [sortAnchorEl, setSortAnchorEl] = useState(null);
  const [statusFilter, setStatusFilter] = useState('all');
  const [sortOption, setSortOption] = useState('newest');
  const [projectMenuAnchorEl, setProjectMenuAnchorEl] = useState(null);
  const [selectedProjectId, setSelectedProjectId] = useState(null);
  const [selectedProjectArchived, setSelectedProjectArchived] = useState(false);
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);
  const [confirmDialogAction, setConfirmDialogAction] = useState('');
  // Add useEffect to refresh projects list after delete/archive
  const [lastAction, setLastAction] = useState({ type: null, timestamp: null });
  // State for pagination limit and archived projects
  const [limitOption, setLimitOption] = useState('all');
  const [showArchived, setShowArchived] = useState(false);
  const [archivedProjectsCount, setArchivedProjectsCount] = useState(0);

  // Function to fetch archived projects count
  const fetchArchivedProjectsCount = async () => {
    try {
      console.log('Fetching archived projects count...');
      const response = await api.get(`/projects?showArchived=true`);
      const projectsData = response.data.projects || response.data || [];
      const archivedProjects = projectsData.filter(p => p.isArchived);
      console.log('Archived projects count:', archivedProjects.length);
      setArchivedProjectsCount(archivedProjects.length);
    } catch (error) {
      console.error('Error fetching archived projects count:', error);
    }
  };

  // Fetch archived projects count on component mount
  useEffect(() => {
    fetchArchivedProjectsCount();
  }, []);

  useEffect(() => {
    const fetchProjects = async () => {
      try {
        setLoading(true);
        console.log('Fetching projects...');
        
        let response;
        
        // Gunakan endpoint yang sesuai berdasarkan peran pengguna
        if (user && (user.role === 'site_engineer' || user.role === 'site_manager')) {
          // Site Engineer dan Site Manager menggunakan endpoint /users/me/projects
          // yang sudah difilter berdasarkan siteEngineerId dan siteManagerId
          console.log('Using /users/me/projects endpoint for site engineer/manager');
          response = await api.get('/users/me/projects');
        } else {
          // Pengguna lain menggunakan endpoint /projects
          console.log(`Using /projects endpoint with limit=${limitOption} and showArchived=${showArchived}`);
          response = await api.get(`/projects?limit=${limitOption}&showArchived=${showArchived}`);
        }
        
        // Periksa struktur respons dan tangani dengan benar
        const projectsData = response.data.projects || response.data || [];
        
        // Tambahkan log untuk debugging
        console.log('Projects data:', projectsData);

        // If we're in the Archive tab, update the archived projects count
        if (tabValue === 2) {
          const archivedProjects = projectsData.filter(p => p.isArchived);
          setArchivedProjectsCount(archivedProjects.length);
        }
        
        // Filter proyek berdasarkan role pengguna sesuai matriks RBAC baru
        let userProjects = projectsData;
        if (user && user.role) {
          // Director, admin, dan commercial dapat melihat semua proyek
          if (user.role === 'admin' || user.role === 'Director' || ['commercial_manager', 'commercial_staff'].includes(user.role)) {
            // Tampilkan semua proyek
            userProjects = projectsData;
          }
          // Project Manager hanya dapat melihat proyek mereka sendiri
          else if (user.role === 'project_manager') {
            userProjects = projectsData.filter(project => 
              (project.members && project.members.some(member => member.userId === user.id)) ||
              project.createdBy === user.id ||
              project.managerId === user.id ||
              (project.manager && project.manager.id === user.id)
            );
          }
          // Client/Stakeholder hanya dapat melihat proyek miliknya
          else if (user.role === 'customer' || user.role === 'stakeholder' || user.role === 'client') {
            // Customer users should see projects associated with their client IDs
            // The backend already filters projects by client IDs associated with the user
            // No additional filtering needed here as the backend handles it correctly
            userProjects = projectsData;
          }
          // Site Manager/Engineer projects are already filtered by the /users/me/projects endpoint
          // Tidak perlu filter tambahan untuk site_manager dan site_engineer
        }
        
        console.log('Filtered projects for user:', userProjects);
        
        setProjects(userProjects);
        setLoading(false);
      } catch (error) {
        console.error('Error fetching projects:', error);
        // Tampilkan pesan error yang lebih informatif
        setError(`Gagal memuat proyek: ${error.message || 'Silakan coba lagi nanti'}`);
        setLoading(false);
      }
    };

    fetchProjects();
  }, [user, showArchived, limitOption, tabValue]);

  useEffect(() => {
    // Skip on initial render
    if (lastAction.type && lastAction.timestamp) {
      console.log(`Refreshing projects list after ${lastAction.type} action`);
      const fetchProjects = async () => {
        try {
          setLoading(true);
          console.log('Fetching projects after action...');
          
          const response = await api.get(`/projects?limit=${limitOption}&showArchived=${showArchived}`);
          
          const projectsData = response.data.projects || response.data || [];
          
          // Always refresh archived projects count after any action
          fetchArchivedProjectsCount();
          
          // Filter proyek berdasarkan role pengguna sesuai matriks RBAC baru
          let userProjects = projectsData;
          if (user && user.role) {
            // Logic for filtering projects based on user role
            // Keeping the same logic as before
            if (user.role === 'admin' || user.role === 'Director' || ['commercial_manager', 'commercial_staff'].includes(user.role)) {
              userProjects = projectsData;
            } else if (user.role === 'project_manager' || user.role === 'site_manager' || user.role === 'site_engineer') {
              userProjects = projectsData.filter(project => 
                (project.members && project.members.some(member => member.userId === user.id)) ||
                project.createdBy === user.id ||
                project.managerId === user.id ||
                (project.manager && project.manager.id === user.id)
              );
            } else if (user.role === 'customer' || user.role === 'stakeholder' || user.role === 'client') {
              // Customer users should see projects associated with their client IDs
              // The backend already filters projects by client IDs associated with the user
              // No additional filtering needed here as the backend handles it correctly
              userProjects = projectsData;
            }
          }
          
          console.log('Refreshed projects list:', userProjects);
          setProjects(userProjects);
        } catch (error) {
          console.error('Error refreshing projects:', error);
        } finally {
          setLoading(false);
        }
      };
      
      fetchProjects();
    }
  }, [lastAction, user, showArchived, limitOption]);

  // Format currency for display
  const formatCurrency = (amount) => {
    if (!amount || amount === 0) return t('BELUM DITENTUKAN');
    
    // Convert to number if it's a string
    const numAmount = typeof amount === 'string' ? parseFloat(amount) : amount;
    
    // Format as Indonesian Rupiah
    return new Intl.NumberFormat('id-ID', {
      style: 'currency',
      currency: 'IDR',
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    }).format(numAmount);
  };

  // Format status text for display
  const formatStatus = (status) => {
    if (!status) return t('IN PROGRESS');
    
    // Convert status to lowercase for comparison
    const statusLower = status.toLowerCase();
    
    // Format different status variations
    if (statusLower === 'in_progress') return t('IN PROGRESS');
    if (statusLower === 'on_hold') return t('ON HOLD');
    
    // Capitalize first letter of each word
    return status.split('_').map(word => 
      word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
    ).join(' ');
  };

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case 'in progress':
      case 'in_progress':
        return '#2196F3';  // Blue color for in progress
      case 'completed':
        return '#4CAF50';  // Green color for completed
      case 'pending':
        return '#FF9800';  // Orange color for pending
      case 'archived':
        return '#9E9E9E';  // Gray color for archived projects
      case 'on_hold':
      case 'on hold':
        return '#E91E63';  // Pink color for on-hold projects
      case 'cancelled':
        return '#F44336';  // Red color for cancelled projects
      default:
        return '#2196F3';  // Default to blue
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    
    // Filter projects based on tab selection
    switch (newValue) {
      case 0: // All Projects - don't show archived projects
        // Reset status filter but keep "isArchived: false" implicit filter
        setStatusFilter('all');
        setShowArchived(false); // Set showArchived to false for All Projects tab
        // Refresh archived projects count when switching to All Projects tab
        fetchArchivedProjectsCount();
        break;
      case 1: // My Projects - don't show archived projects
        // Show only projects where the current user is involved
        setStatusFilter('all');
        setShowArchived(false); // Set showArchived to false for My Projects tab
        // We'll filter the projects in the filteredProjects function
        // Refresh archived projects count when switching to My Projects tab
        fetchArchivedProjectsCount();
        break;
      case 2: // Archive - show only archived projects
        // Show only archived projects
        setStatusFilter('all'); // Reset status filter, we'll use isArchived flag
        setShowArchived(true); // Set showArchived to true for Archive tab
        // Refresh archived projects count when switching to Archive tab
        fetchArchivedProjectsCount();
        break;
      default:
        setStatusFilter('all');
        setShowArchived(false); // Default to false
    }
  };

  const handleFilterClick = (event) => {
    setFilterAnchorEl(event.currentTarget);
  };

  const handleFilterClose = () => {
    setFilterAnchorEl(null);
  };

  const handleSortClick = (event) => {
    setSortAnchorEl(event.currentTarget);
  };

  const handleSortClose = () => {
    setSortAnchorEl(null);
  };

  const handleStatusFilterChange = (status) => {
    setStatusFilter(status);
    handleFilterClose();
  };

  const handleSortOptionChange = (option) => {
    setSortOption(option);
    handleSortClose();
  };

  if (loading) {
    return (
      <MainLayout>
        <Container maxWidth="xl" sx={{ px: { xs: 1, sm: 2, md: 3 } }}>
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '80vh' }}>
            <CircularProgress sx={{ color: '#F0C14B' }} />
          </Box>
        </Container>
      </MainLayout>
    );
  }

  // Use actual projects data from API
  const projectsToShow = projects;

  const filteredProjects = projectsToShow.filter(project => {
    // First check for Archives tab special case
    if (tabValue === 2) {
      // In Archive tab, only show archived projects regardless of other filters
      // For Archive tab, we've already fetched only archived projects, but double-check
      return project.isArchived === true && 
             // Still respect search query
             (project.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
             (project.location && project.location.toLowerCase().includes(searchQuery.toLowerCase())));
    }
    
    // For other tabs
    // Filter by search query
    const matchesSearch = project.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
                         (project.location && project.location.toLowerCase().includes(searchQuery.toLowerCase()));
    
    // Filter by status
    const matchesStatus = statusFilter === 'all' || 
                         (project.status && project.status.toLowerCase() === statusFilter.toLowerCase());
    
    // Filter by tab
    let matchesTab = true;
    if (tabValue === 0) { // All Projects
      // Don't show archived projects unless showArchived is true
      matchesTab = showArchived ? true : project.isArchived !== true;
    } else if (tabValue === 1) { // My Projects
      // Show only projects where the current user is involved
      // Only show archived projects if showArchived is true
      const isArchived = project.isArchived === true;
      matchesTab = (showArchived ? true : !isArchived) && (
                  (project.members && project.members.some(member => member.userId === user.id)) ||
                  project.createdBy === user.id ||
                  project.managerId === user.id ||
                  (project.manager && project.manager.id === user.id));
    }
    
    return matchesSearch && matchesStatus && matchesTab;
  }).sort((a, b) => {
    // Sort by selected option
    switch (sortOption) {
      case 'newest':
        return new Date(b.startDate || '2023-01-01') - new Date(a.startDate || '2023-01-01');
      case 'oldest':
        return new Date(a.startDate || '2023-01-01') - new Date(b.startDate || '2023-01-01');
      case 'name_asc':
        return a.name.localeCompare(b.name);
      case 'name_desc':
        return b.name.localeCompare(a.name);
      case 'budget_high':
        return (parseFloat(b.totalAnggaran || 0) - parseFloat(a.totalAnggaran || 0));
      case 'budget_low':
        return (parseFloat(a.totalAnggaran || 0) - parseFloat(b.totalAnggaran || 0));
      case 'status_asc':
        return (a.status || '').localeCompare(b.status || '');
      case 'status_desc':
        return (b.status || '').localeCompare(a.status || '');
      default:
        return 0;
    }
  });

  const handleProjectMenuClick = (event, projectId) => {
    // Stop event propagation to prevent other handlers from firing
    event.stopPropagation();
    
    // Find the project to check if it's archived
    const project = projects.find(p => p.id === projectId);
    
    // Set the selected project ID and archived status
    setSelectedProjectId(projectId);
    setSelectedProjectArchived(project?.isArchived || false);
    
    // Open the menu
    setProjectMenuAnchorEl(event.currentTarget);
  };

  const handleProjectMenuClose = () => {
    console.log('Closing menu, current selected project ID:', selectedProjectId);
    setProjectMenuAnchorEl(null);
  };

  const handleArchiveProject = (projectId) => {
    // Close the menu first
    setProjectMenuAnchorEl(null);
    
    // Use the provided projectId directly instead of state
    console.log('Archive project action for ID:', projectId);
    
    // Show confirmation dialog
    setSelectedProjectId(projectId);
    setConfirmDialogAction('archive');
    setConfirmDialogOpen(true);
  };

  const handleDeleteProject = (projectId) => {
    // Close the menu first
    setProjectMenuAnchorEl(null);
    
    // Use the provided projectId directly instead of state
    console.log('Delete project action for ID:', projectId);
    
    // Show confirmation dialog
    setSelectedProjectId(projectId);
    setConfirmDialogAction('delete');
    setConfirmDialogOpen(true);
  };

  const handleRestoreProject = (projectId) => {
    // Close the menu first
    setProjectMenuAnchorEl(null);
    
    // Use the provided projectId directly instead of state
    console.log('Restore project action for ID:', projectId);
    
    // Show confirmation dialog
    setSelectedProjectId(projectId);
    setConfirmDialogAction('restore');
    setConfirmDialogOpen(true);
  };

  const handleConfirmDialogClose = () => {
    setConfirmDialogOpen(false);
  };

  const handleConfirmAction = async () => {
    if (!selectedProjectId) {
      console.error('No project selected for action');
      enqueueSnackbar('No project selected', { variant: 'error' });
      setConfirmDialogOpen(false);
      return;
    }

    try {
      // Store the ID in a local variable to ensure it doesn't change during async operations
      const projectId = Number(selectedProjectId);
      console.log(`Attempting to ${confirmDialogAction} project with ID: ${projectId}`);
      
      if (confirmDialogAction === 'archive') {
        // Archive project
        console.log(`Making API call to: /projects/${projectId}/archive`);
        const response = await api.put(`/projects/${projectId}/archive`);
        console.log('Archive API response:', response.data);
        
        // Use the project data from the response if available
        if (response.data.project) {
          setProjects(prevProjects => 
            prevProjects.map(project => 
              project.id === projectId 
                ? { ...project, ...response.data.project } 
                : project
            )
          );
        } else {
          // Fallback to simple update
          setProjects(prevProjects => 
            prevProjects.map(project => 
              project.id === projectId 
                ? { ...project, isArchived: true, status: 'archived' } 
                : project
            )
          );
        }
        
        // Track successful action
        setLastAction({ type: 'archive', timestamp: new Date().getTime() });
        
        // Update archived projects count
        fetchArchivedProjectsCount();
        
        // Switch to Archive tab to show the newly archived project
        setTabValue(2);
        
        enqueueSnackbar(response.data.message || 'Project has been archived successfully', { variant: 'success' });
      } else if (confirmDialogAction === 'delete') {
        // Delete project
        console.log(`Making API call to: /projects/${projectId}`);
        const response = await api.delete(`/projects/${projectId}`);
        console.log('Delete API response:', response.data);
        
        // If the project was archived instead of deleted (has dependencies)
        if (response.data.isArchived) {
          // Update local state - mark as archived instead of removing
          setProjects(prevProjects => 
            prevProjects.map(project => 
              project.id === projectId 
                ? { ...project, isArchived: true } 
                : project
            )
          );
          
          // Update archived projects count
          fetchArchivedProjectsCount();
          
          // Switch to Archive tab to show the newly archived project
          setTabValue(2);
          
          enqueueSnackbar(response.data.message, { variant: 'info' });
        } else {
          // Normal delete - remove from projects array
          setProjects(prevProjects => 
            prevProjects.filter(project => project.id !== projectId)
          );
          
          enqueueSnackbar('Project has been deleted successfully', { variant: 'success' });
        }
        
        // Track successful action
        setLastAction({ type: 'delete', timestamp: new Date().getTime() });
      } else if (confirmDialogAction === 'restore') {
        // Restore project
        console.log(`Making API call to: /projects/${projectId}/restore`);
        const response = await api.post(`/projects/${projectId}/restore`);
        console.log('Restore API response:', response.data);
        
        // Update local state - mark as not archived
        setProjects(prevProjects => 
          prevProjects.map(project => 
            project.id === projectId 
              ? { ...project, isArchived: false, status: 'in_progress' } 
              : project
          )
        );
        
        // Switch to All Projects tab to show the restored project
        setTabValue(0);
        
        // Track successful action
        setLastAction({ type: 'restore', timestamp: new Date().getTime() });
        
        // Update archived projects count
        fetchArchivedProjectsCount();
        
        enqueueSnackbar(response.data.message || 'Project has been restored successfully', { variant: 'success' });
      }
    } catch (error) {
      console.error(`Error ${confirmDialogAction}ing project:`, error);
      
      // Add more detailed error logging
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.error('Error response data:', error.response.data);
        console.error('Error response status:', error.response.status);
        console.error('Error response headers:', error.response.headers);
        
        // Show more specific error message based on status code
        if (error.response.status === 403) {
          enqueueSnackbar(`Permission denied. You don't have sufficient privileges to ${confirmDialogAction} this project.`, { variant: 'error' });
        } else if (error.response.status === 404) {
          enqueueSnackbar('Project not found. It may have been already deleted.', { variant: 'error' });
        } else if (error.response.status === 400) {
          // Show the server's error message if available
          const errorMessage = error.response.data?.message || `Failed to ${confirmDialogAction} project.`;
          enqueueSnackbar(errorMessage, { variant: 'error' });
        } else {
          enqueueSnackbar(`Failed to ${confirmDialogAction} project. Server returned: ${error.response.status}`, { variant: 'error' });
        }
      } else if (error.request) {
        // The request was made but no response was received
        console.error('Error request:', error.request);
        enqueueSnackbar(`Failed to ${confirmDialogAction} project. No response from server. Check your connection.`, { variant: 'error' });
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error('Error message:', error.message);
        enqueueSnackbar(`Failed to ${confirmDialogAction} project: ${error.message}`, { variant: 'error' });
      }
    } finally {
      setConfirmDialogOpen(false);
      // Do not clear selectedProjectId until after dialog closes
      setTimeout(() => {
        setSelectedProjectId(null);
      }, 300);
    }
  };

  const handleCreateProject = () => {
    navigate('/projects/create');
  };

  return (
    <Box sx={{ width: '100%', px: 0 }}>
        {/* Header with blue gradient */}
        <Paper
          elevation={0}
          sx={{
            p: { xs: 3, sm: 4 },
            mb: 4,
            borderRadius: 3,
            background: 'linear-gradient(135deg, #0f172a, #1e3a5f, #1e40af)',
            position: 'relative',
            overflow: 'hidden',
            '&::before': {
              content: '""',
              position: 'absolute',
              top: 0,
              right: 0,
              width: '40%',
              height: '100%',
              background: 'radial-gradient(circle at top right, rgba(59, 130, 246, 0.2), transparent 70%)',
              pointerEvents: 'none'
            }
          }}
        >
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={2}
            alignItems={{ xs: 'flex-start', md: 'center' }}
            justifyContent="space-between"
            position="relative"
            zIndex={1}
          >
            <Box>
              <Typography variant="h4" sx={{ fontWeight: 800, color: '#ffffff', mb: 1 }}>
                Projects
              </Typography>
              <Typography variant="body1" sx={{ color: 'rgba(255, 255, 255, 0.85)' }}>
                {t('Kelola daftar proyek aktif, arsip, dan proyek yang Anda tangani.')}
              </Typography>
            </Box>
            {user && (user.role === 'admin' || user.role === 'Director' || ['commercial_manager', 'commercial_staff'].includes(user.role)) && (
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={handleCreateProject}
                sx={{
                  bgcolor: 'rgba(255, 255, 255, 0.15)',
                  backdropFilter: 'blur(10px)',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  color: '#ffffff',
                  fontWeight: 700,
                  '&:hover': {
                    bgcolor: 'rgba(255, 255, 255, 0.25)',
                    border: '1px solid rgba(255, 255, 255, 0.3)'
                  }
                }}
              >
                {t('BUAT PROYEK')}
              </Button>
            )}
          </Stack>
        </Paper>

        {/* Search and Filter Bar */}
        <Paper
          elevation={0}
          sx={{
            p: { xs: 2, sm: 2.5 },
            mb: 3,
            borderRadius: 2,
            border: '1px solid',
            borderColor: 'rgba(15, 23, 42, 0.1)',
            bgcolor: '#FFFFFF',
            boxShadow: '0 1px 2px rgba(15, 23, 42, 0.04), 0 1px 3px rgba(15, 23, 42, 0.06)'
          }}
        >
          <Stack
            direction={{ xs: 'column', md: 'row' }}
            spacing={2}
            alignItems={{ xs: 'stretch', md: 'center' }}
            justifyContent="space-between"
          >
            <Paper
              component="form"
              elevation={0}
              sx={{
                px: 1.75,
                py: 0.75,
                display: 'flex',
                alignItems: 'center',
                width: { xs: '100%', md: 320 },
                borderRadius: 2,
                border: '1px solid',
                borderColor: 'rgba(15, 23, 42, 0.1)',
                bgcolor: '#F8FAFC'
              }}
            >
              <SearchIcon sx={{ fontSize: 18, color: '#64748B' }} />
              <InputBase
                sx={{ ml: 1, flex: 1, fontSize: '0.9rem', color: '#0f172a' }}
                placeholder={t('CARI PROYEK...')}
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
              />
            </Paper>

            <Stack direction="row" spacing={1} flexWrap="wrap">
              <Button
                variant="outlined"
                startIcon={<FilterListIcon />}
                onClick={handleFilterClick}
                sx={{
                  borderColor: 'rgba(15, 23, 42, 0.2)',
                  color: '#0f172a',
                  fontWeight: 600,
                  '&:hover': { borderColor: 'rgba(59, 130, 246, 0.4)', backgroundColor: 'rgba(59, 130, 246, 0.04)' }
                }}
              >
                {t('FILTER')}
              </Button>
              <Button
                variant="outlined"
                startIcon={<SortIcon />}
                onClick={handleSortClick}
                sx={{
                  borderColor: 'rgba(15, 23, 42, 0.2)',
                  color: '#0f172a',
                  fontWeight: 600,
                  '&:hover': { borderColor: 'rgba(59, 130, 246, 0.4)', backgroundColor: 'rgba(59, 130, 246, 0.04)' }
                }}
              >
                {t('URUTKAN')}
              </Button>
              <TextField
                select
                size="small"
                value={limitOption}
                onChange={(e) => {
                  setLimitOption(e.target.value);
                  setLastAction({
                    type: 'change_limit',
                    timestamp: new Date().getTime()
                  });
                }}
                sx={{ minWidth: 160 }}
              >
                <MenuItem value="all">{t('SEMUA PROYEK')}</MenuItem>
                <MenuItem value="10">10</MenuItem>
                <MenuItem value="25">25</MenuItem>
                <MenuItem value="50">50</MenuItem>
                <MenuItem value="100">100</MenuItem>
              </TextField>
            </Stack>
          </Stack>

          <Stack direction="row" spacing={1} flexWrap="wrap" sx={{ mt: 2 }}>
            <Chip
              size="small"
              variant="outlined"
              label={`${t('STATUS')}: ${statusFilter === 'all' ? t('SEMUA') : statusFilter}`}
              onClick={handleFilterClick}
              sx={{
                borderColor: 'rgba(15, 23, 42, 0.2)',
                color: '#475569',
                fontWeight: 600,
                '&:hover': { borderColor: 'rgba(59, 130, 246, 0.4)', backgroundColor: 'rgba(59, 130, 246, 0.04)' }
              }}
            />
            <Chip
              size="small"
              variant="outlined"
              label={showArchived ? t('ARSIP: TAMPIL') : t('ARSIP: SEMBUNYI')}
              onClick={() => setShowArchived(!showArchived)}
              sx={{
                borderColor: 'rgba(15, 23, 42, 0.2)',
                color: '#475569',
                fontWeight: 600,
                '&:hover': { borderColor: 'rgba(59, 130, 246, 0.4)', backgroundColor: 'rgba(59, 130, 246, 0.04)' }
              }}
            />
            <Chip
              size="small"
              variant="outlined"
              label={`${t('URUTKAN')}: ${sortOption}`}
              onClick={handleSortClick}
              sx={{
                borderColor: 'rgba(15, 23, 42, 0.2)',
                color: '#475569',
                fontWeight: 600,
                '&:hover': { borderColor: 'rgba(59, 130, 246, 0.4)', backgroundColor: 'rgba(59, 130, 246, 0.04)' }
              }}
            />
          </Stack>
        </Paper>
          <Menu
            anchorEl={filterAnchorEl}
            open={Boolean(filterAnchorEl)}
            onClose={handleFilterClose}
          >
            <MenuItem onClick={() => handleStatusFilterChange('all')} selected={statusFilter === 'all'}>
              {t('SEMUA STATUS')}
            </MenuItem>
            <MenuItem onClick={() => handleStatusFilterChange('in progress')} selected={statusFilter === 'in progress'}>
              {t('DALAM PROSES')}
            </MenuItem>
            <MenuItem onClick={() => handleStatusFilterChange('completed')} selected={statusFilter === 'completed'}>
              {t('SELESAI')}
            </MenuItem>
            <Divider />
            <MenuItem 
              onClick={() => {
                setShowArchived(!showArchived);
                handleFilterClose();
              }}
            >
              {showArchived ? `✓ ${t('TAMPILKAN PROYEK TERARSIP')}` : `○ ${t('TAMPILKAN PROYEK TERARSIP')}`}
            </MenuItem>
            <MenuItem onClick={() => handleStatusFilterChange('pending')} selected={statusFilter === 'pending'}>
              {t('MENUNGGU')}
            </MenuItem>
          </Menu>
          <Menu
            anchorEl={sortAnchorEl}
            open={Boolean(sortAnchorEl)}
            onClose={handleSortClose}
          >
            <MenuItem onClick={() => handleSortOptionChange('newest')} selected={sortOption === 'newest'}>
              {t('TERBARU')}
            </MenuItem>
            <MenuItem onClick={() => handleSortOptionChange('oldest')} selected={sortOption === 'oldest'}>
              {t('TERLAMA')}
            </MenuItem>
            <MenuItem onClick={() => handleSortOptionChange('name_asc')} selected={sortOption === 'name_asc'}>
              {t('NAMA (A-Z)')}
            </MenuItem>
            <MenuItem onClick={() => handleSortOptionChange('name_desc')} selected={sortOption === 'name_desc'}>
              {t('NAMA (Z-A)')}
            </MenuItem>
            <MenuItem onClick={() => handleSortOptionChange('budget_high')} selected={sortOption === 'budget_high'}>
              {t('ANGGARAN (TERTINGGI)')}
            </MenuItem>
            <MenuItem onClick={() => handleSortOptionChange('budget_low')} selected={sortOption === 'budget_low'}>
              {t('ANGGARAN (TERRENDAH)')}
            </MenuItem>
            <MenuItem onClick={() => handleSortOptionChange('status_asc')} selected={sortOption === 'status_asc'}>
              {t('STATUS (A-Z)')}
            </MenuItem>
            <MenuItem onClick={() => handleSortOptionChange('status_desc')} selected={sortOption === 'status_desc'}>
              {t('STATUS (Z-A)')}
            </MenuItem>
          </Menu>

        {/* Tabs */}
        <Paper
          elevation={0}
          sx={{
            mb: 3,
            borderRadius: 2,
            border: '1px solid',
            borderColor: 'rgba(15, 23, 42, 0.1)',
            bgcolor: '#FFFFFF',
            boxShadow: '0 1px 2px rgba(15, 23, 42, 0.04), 0 1px 3px rgba(15, 23, 42, 0.06)',
            overflow: 'hidden'
          }}
        >
          <Tabs
            value={tabValue}
            onChange={handleTabChange}
            aria-label="project tabs"
            variant="scrollable"
            scrollButtons="auto"
            sx={{
              px: { xs: 1, sm: 2 },
              pt: 1,
              minHeight: 48,
              bgcolor: '#F8FAFC',
              borderBottom: '1px solid',
              borderColor: 'rgba(15, 23, 42, 0.08)',
              '& .MuiTabs-flexContainer': { gap: 0.5 },
              '& .MuiTab-root': {
                fontSize: '0.85rem',
                color: '#64748B',
                fontWeight: 600,
                textTransform: 'none',
                minHeight: 44,
                px: 2,
                borderRadius: '8px 8px 0 0',
                transition: 'color 160ms ease, background-color 160ms ease',
                '&:hover': {
                  color: '#1e40af',
                  backgroundColor: 'rgba(59, 130, 246, 0.06)'
                }
              },
              '& .Mui-selected': {
                color: '#1e40af !important',
                fontWeight: 700,
                backgroundColor: '#FFFFFF'
              },
              '& .MuiTabs-indicator': {
                height: 3,
                borderRadius: '3px 3px 0 0',
                background: 'linear-gradient(90deg, #3B82F6, #1e40af)'
              }
            }}
          >
            <Tab
              label={`${t('SEMUA PROYEK')} (${projects.filter(p => !p.isArchived).length})`}
              sx={{ minHeight: '44px' }}
            />
            <Tab
              label={`${t('PROYEK SAYA')} (${projects.filter(p => !p.isArchived &&
                ((p.members && p.members.some(member => member.userId === user?.id)) ||
                p.createdBy === user?.id ||
                p.managerId === user?.id ||
                (p.manager && p.manager.id === user?.id))).length})`}
              sx={{ minHeight: '44px' }}
            />
            <Tab
              label={`${t('ARSIP')} (${archivedProjectsCount})`}
              sx={{ minHeight: '44px' }}
            />
          </Tabs>
        </Paper>

        {tabValue === 2 && (
          <Paper
            elevation={0}
            sx={{
              p: 2.5,
              mb: 3,
              borderRadius: 2,
              border: '1px solid',
              borderColor: 'rgba(15, 23, 42, 0.1)',
              bgcolor: '#F8FAFC',
              boxShadow: '0 1px 2px rgba(15, 23, 42, 0.04), 0 1px 3px rgba(15, 23, 42, 0.06)'
            }}
          >
            <Typography variant="body2" sx={{ color: '#475569', fontWeight: 600 }}>
              <strong>{t('ARSIP')}:</strong> {t('PROYEK INI TELAH DIARSIPKAN DAN TIDAK LAGI AKTIF. PROYEK TERARSIP BERSIFAT BACA SAJA.')}
            </Typography>
          </Paper>
        )}

        {error ? (
          <Paper
            elevation={0}
            sx={{
              p: 3,
              textAlign: 'center',
              color: 'error.main',
              borderRadius: 2,
              border: '1px solid',
              borderColor: 'rgba(239, 68, 68, 0.2)',
              bgcolor: '#ffffff',
              boxShadow: '0 1px 2px rgba(15, 23, 42, 0.04), 0 1px 3px rgba(15, 23, 42, 0.06)'
            }}
          >
            {error}
          </Paper>
        ) : (
          <Box
            sx={{
              display: 'grid',
              gridTemplateColumns: { xs: '1fr', sm: 'repeat(2, minmax(0, 1fr))', lg: 'repeat(3, minmax(280px, 1fr))' },
              gap: 2.5
            }}
          >
            {filteredProjects.map((project) => (
              <Card
                key={project.id}
                elevation={0}
                sx={{
                  height: '100%',
                  display: 'flex',
                  flexDirection: 'column',
                  borderRadius: 2,
                  border: '1px solid',
                  borderColor: 'rgba(15, 23, 42, 0.12)',
                  bgcolor: '#ffffff',
                  opacity: project.isArchived ? 0.9 : 1,
                  boxShadow: '0 1px 2px rgba(15, 23, 42, 0.04), 0 1px 3px rgba(15, 23, 42, 0.06)',
                  transition: 'transform 160ms ease, box-shadow 160ms ease, border-color 160ms ease',
                  '&:hover': {
                    transform: 'translateY(-2px)',
                    boxShadow: '0 10px 24px rgba(15, 23, 42, 0.1)',
                    borderColor: 'rgba(59, 130, 246, 0.3)'
                  }
                }}
              >
                <CardContent sx={{ flexGrow: 1, p: 2 }}>
                  <Stack direction="row" alignItems="flex-start" justifyContent="space-between" spacing={1}>
                    <Box sx={{ minWidth: 0 }}>
                      <Typography variant="subtitle1" sx={{ fontWeight: 700, color: '#0f172a' }}>
                        {project.name}
                      </Typography>
                      <Stack direction="row" spacing={0.5} alignItems="center" sx={{ mt: 0.5 }}>
                        <LocationOnIcon sx={{ fontSize: 16, color: '#64748B' }} />
                        <Typography variant="caption" color="text.secondary" noWrap>
                          {project.location || t('LOKASI TIDAK TERSEDIA')}
                        </Typography>
                      </Stack>
                    </Box>
                    <IconButton 
                      size="small" 
                      onClick={(e) => handleProjectMenuClick(e, project.id)}
                    >
                      <MoreVertIcon fontSize="small" />
                    </IconButton>
                  </Stack>

                  <Stack direction="row" spacing={1} alignItems="center" sx={{ mt: 2, flexWrap: 'wrap' }}>
                    <Chip 
                      label={project.isArchived ? t('DIARSIPKAN') : formatStatus(project.status || 'In Progress')} 
                      size="small" 
                      sx={{ 
                        backgroundColor: project.isArchived ? '#9E9E9E' : getStatusColor(project.status),
                        color: 'white',
                        fontWeight: 700
                      }} 
                    />
                    <Typography variant="caption" sx={{ color: '#64748B', display: 'flex', alignItems: 'center' }}>
                      <CalendarTodayIcon sx={{ fontSize: 14, mr: 0.5 }} />
                      {new Date(project.startDate || '2023-04-01').toLocaleDateString('id-ID')}
                    </Typography>
                  </Stack>

                  <Divider sx={{ my: 2 }} />

                  <Typography variant="body2" sx={{ color: '#475569' }}>
                    <strong>{t('ANGGARAN')}:</strong> {formatCurrency(project.totalAnggaran)}
                  </Typography>
                  <Stack direction="row" spacing={0.5} alignItems="center" sx={{ mt: 1 }}>
                    <PersonIcon sx={{ fontSize: 16, color: '#64748B' }} />
                    <Typography variant="body2" color="text.secondary">
                      {project.manager ? 
                        (typeof project.manager === 'object' ? 
                          (project.manager.fullName || project.manager.username || t('TIDAK DIKETAHUI')) 
                          : project.manager) 
                        : t('BELUM DITENTUKAN')} (PM)
                    </Typography>
                  </Stack>
                </CardContent>
                <CardActions sx={{ justifyContent: 'space-between', px: 2, pb: 2 }}>
                  <Button 
                    size="small" 
                    onClick={() => navigate(`/dashboard?project=${project.id}`)}
                  >
                    {t('DASBOR')}
                  </Button>
                  <Button 
                    size="small" 
                    variant="contained"
                    onClick={() => navigate(`/projects/${project.id}`)}
                    sx={{ 
                      backgroundColor: '#0f172a',
                      '&:hover': { backgroundColor: '#0b1324' }
                    }}
                  >
                    {t('DETAIL')}
                  </Button>
                </CardActions>
              </Card>
            ))}
          </Box>
        )}

        {filteredProjects.length === 0 && !error && (
          <Paper
            elevation={0}
            sx={{
              p: 4,
              textAlign: 'center',
              borderRadius: 2,
              border: '1px solid',
              borderColor: 'rgba(15, 23, 42, 0.1)',
              bgcolor: '#ffffff',
              boxShadow: '0 1px 2px rgba(15, 23, 42, 0.04), 0 1px 3px rgba(15, 23, 42, 0.06)'
            }}
          >
            <Typography variant="h6" sx={{ color: '#0f172a', fontWeight: 700, mb: 2 }}>
              {searchQuery ? t('TIDAK ADA PROYEK YANG COCOK DENGAN PENCARIAN ANDA') : t('BELUM ADA PROYEK TERSEDIA')}
            </Typography>
            {user && (user.role === 'admin' || user.role === 'Director' || ['commercial_manager', 'commercial_staff'].includes(user.role)) && !searchQuery && (
              <Button
                variant="contained"
                startIcon={<AddIcon />}
                onClick={() => navigate('/projects/create')}
                sx={{
                  backgroundColor: '#3B82F6',
                  color: '#ffffff',
                  fontWeight: 700,
                  '&:hover': {
                    backgroundColor: '#2563EB',
                  }
                }}
              >
                {t('BUAT PROYEK')}
              </Button>
            )}
          </Paper>
        )}
      {/* Project Menu */}
      <Menu
        anchorEl={projectMenuAnchorEl}
        open={Boolean(projectMenuAnchorEl)}
        onClose={handleProjectMenuClose}
      >
        <MenuItem onClick={() => {
          console.log('View Details clicked for project:', selectedProjectId);
          handleProjectMenuClose();
          navigate(`/projects/${selectedProjectId}`);
        }}>
          {t('LIHAT DETAIL')}
        </MenuItem>
        
        {/* Only show Edit option for non-archived projects */}
        {!selectedProjectArchived && (
          <MenuItem onClick={() => {
            console.log('Edit Project clicked for project:', selectedProjectId);
            handleProjectMenuClose();
            navigate(`/projects/${selectedProjectId}/edit`);
          }}>
            {t('UBAH PROYEK')}
          </MenuItem>
        )}
        
        {/* Show Archive or Restore based on project status */}
        {!selectedProjectArchived ? (
          <MenuItem onClick={() => {
            console.log('Archive Project clicked for project:', selectedProjectId);
            handleArchiveProject(selectedProjectId);
          }}>
            {t('ARSIPKAN PROYEK')}
          </MenuItem>
        ) : (
          <MenuItem onClick={() => {
            console.log('Restore Project clicked for project:', selectedProjectId);
            handleRestoreProject(selectedProjectId);
          }} sx={{ color: 'success.main' }}>
            {t('PULIHKAN PROYEK')}
          </MenuItem>
        )}
        
        <MenuItem onClick={() => {
          console.log('Delete Project clicked for project:', selectedProjectId);
          handleDeleteProject(selectedProjectId);
        }} sx={{ color: 'error.main' }}>
          {t('HAPUS PROYEK')}
        </MenuItem>
      </Menu>

      {/* Confirmation Dialog */}
      <Dialog
        open={confirmDialogOpen}
        onClose={handleConfirmDialogClose}
      >
        <DialogTitle>
          {confirmDialogAction === 'archive' ? t('ARSIPKAN PROYEK') : 
           confirmDialogAction === 'restore' ? t('PULIHKAN PROYEK') : t('HAPUS PROYEK')}
        </DialogTitle>
        <DialogContent>
          <DialogContentText>
            {confirmDialogAction === 'archive' 
              ? t('APAKAH ANDA YAKIN INGIN MENGARSIPKAN PROYEK INI? PROYEK YANG DIARSIPKAN DAPAT DILIHAT DI TAB ARSIP.')
              : confirmDialogAction === 'restore'
              ? t('APAKAH ANDA YAKIN INGIN MEMULIHKAN PROYEK INI? PROYEK AKAN DIPINDAHKAN KEMBALI KE DAFTAR PROYEK AKTIF.')
              : t('APAKAH ANDA YAKIN INGIN MENGHAPUS PROYEK INI? TINDAKAN INI TIDAK DAPAT DIBATALKAN.')}
          </DialogContentText>
          <Typography variant="subtitle2" color="textSecondary" sx={{ mt: 2 }}>
            {t('ID PROYEK')}: {selectedProjectId}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => {
            console.log('Cancel clicked in confirmation dialog');
            handleConfirmDialogClose();
          }} color="primary">
            {t('BATAL')}
          </Button>
          <Button 
            onClick={() => {
              console.log(`Confirm ${confirmDialogAction} clicked for project ID:`, selectedProjectId);
              handleConfirmAction();
            }} 
            color={confirmDialogAction === 'delete' ? 'error' : 'primary'} 
            variant="contained"
            autoFocus
          >
            {confirmDialogAction === 'archive' ? t('ARSIPKAN') : confirmDialogAction === 'restore' ? t('PULIHKAN') : t('HAPUS')}
          </Button>
        </DialogActions>
      </Dialog>
    </Box>
  );
};

export default Projects;
